'use strict';

exports.__esModule = true;
var WIDGETS = exports.WIDGETS = {
  SHOW_SNACK_BAR: 'SHOW_SNACK_BAR',
  HIDE_SNACK_BAR: 'HIDE_SNACK_BAR'
};

var showSnackBar = exports.showSnackBar = function showSnackBar(message, color, backgroundColor, icon) {
  return {
    type: WIDGETS.SHOW_SNACK_BAR,
    message: message,
    color: color,
    backgroundColor: backgroundColor,
    icon: icon
  };
};

var hideSnackBar = exports.hideSnackBar = function hideSnackBar() {
  return {
    type: WIDGETS.HIDE_SNACK_BAR
  };
};